<template>
    <v-flex v-if="match" xs12>

        <v-card >
            <v-card-text>
                <v-container fluid>
                    <v-layout row wrap>
                        <v-flex  xs12 text-xs-left mb-1>
                            <v-icon class="mr-2">location_on</v-icon>
                            <span  class="black--text subheading">{{match.court.name}}, </span>
                            <span class="subheading">{{match.court.address}}</span>
                        </v-flex>
                        <v-flex xs12 text-xs-left>
                            <v-icon class="mr-2">event</v-icon>
                            <span class="subheading">{{matchDate}}</span>
                        </v-flex>
                    </v-layout>
                    <v-layout row wrap>
                        <v-flex xs12 sm5>
                            <v-card light>
                                <v-card-text :style="{ 'display': 'flex', 'align-items': 'center' }">
                                    <div
                                        class="fab-img"
                                        :style="{'background-image': 'url('+getImage(match.team_a.image) +')'}"
                                    ></div>
                                    <span  class="pl-2">{{match.team_a.name}}</span>
                                </v-card-text>
                            </v-card>
                        </v-flex>
                        <v-flex xs12 sm2 d-flex align-center justify-center headline>
                            <v-flex xs12 sm3 d-flex align-center justify-center headline>
                              <span   class="score-text">
                                {{teamAGoals}}
                              </span>


                            </v-flex>
                            <v-flex xs12 sm4 d-flex align-center justify-center headline>VS</v-flex>

                            <v-flex xs12 sm3 d-flex align-center justify-center headline>
                              <span class="score-text">
                                {{teamBGoals}}
                              </span>


                            </v-flex>
                        </v-flex>
                        <v-flex xs12 sm5>
                            <v-card light>
                                <v-card-text :style="{ 'display': 'flex', 'align-items': 'center' }">
                                    <div
                                        class="fab-img"
                                        :style="{'background-image': 'url('+getImage(match.team_b.image)+')'}"
                                    ></div>
                                    <span class="pl-2">{{match.team_b.name}}</span>
                                </v-card-text>
                            </v-card>
                        </v-flex>
                    </v-layout>
                </v-container>
            </v-card-text>
        </v-card>


    </v-flex>


</template>
<script>

import moment from 'moment'
export default {
  name: "IframeMatchRow",
  components: {

  },
  props: {
    match:{required:true, default:null}
  },
  data: () => ({

  }),
  created() {
    //do something after creating vue instance
  },
  watch:{
    match(match){

    }
  },
  computed:{
    matchDate(){
      var localLocale = moment(this.match.date);
      moment.locale('es');
      localLocale.locale(false);
      return localLocale.format('MMMM DD [del] YYYY [a] hh:mm a')
    },
    teamAGoals(){
      return this.match.result ? this.match.result.gol : "-"
    },
    teamBGoals(){
      return this.match.result ? this.match.result.opponent_gol : "-"
    }



  },
  methods: {
    formatDate(date){
      var localLocale = moment(date);
      moment.locale('es');
      localLocale.locale(false);
      return localLocale.format('LLLL')
    },
    getImage(image){
      return image.original ? image.original : image.letter;
    }

  }
}
</script>
<style lang="css" scoped>
.score-text{
  width: 100%;
  text-align: center;
  border: 1px solid;
}
.fab-img {
  background-size: cover;
  background-position: center;
  background-repeat: no-repeat;
  width: 60px;
  height: 60px;
  border-radius: 50%;
  box-shadow: 0 3px 5px -1px rgba(0,0,0,.2), 0 6px 10px rgba(0,0,0,.14), 0 1px 18px rgba(0,0,0,.12);
}
.table-statistic {
    width: 35px;
    height: 35px;
    border-radius: 50%;
    display: flex;
    justify-content: center;
    align-items: center;
}
.horizontal-flex {
    display: flex;
    justify-content: center;
    align-items: center;
}
</style>



// WEBPACK FOOTER //
// src/components/pages/iframe/iframeMatchRow.vue